import React, { Component } from 'react';
import { connect } from 'react-redux';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import ApplicationMessages from '../inAppMessages/ApplicationMessages';
import ReactTable from "react-table";
import NoData from '../page/NoData';
import Pagination from '../page/Pagination';
import ActionsMenu from './ActionsMenu';
import DATES from '../../utils/formattedDates';
import AuthorizedResource from '../authorization/AuthorizedResource';
import authorize from '../../utils/auth';
import Logger, { LOG_LEVELS, ALL_MESSAGES } from '../../utils/logger';

import COUNTRIESONHOLD_CONTROLLER from '../../controllers/countriesOnHold';

import ActionsModal from './ActionsModal';
import { TableConfig } from '../../utils/appConfig';

const FORM_NAME = 'COUNTRIES_ON_HOLD_PAGE';
const log = new Logger(FORM_NAME, LOG_LEVELS.DEBUG);

const actions = {
  UNLOCK_LOGISTICAL: 'UnlockLogistical',
  UNLOCK_FINANCIAL: 'UnlockFinancial',
  UNLOCK_BOTH: 'UnlockBoth',
  UNLOCK_ALL: 'UnlockAll',
  LOCK_LOGISTICAL: 'LockLogistical',
  LOCK_FINANCIAL: 'LockFinancial',
  LOCK_BOTH: 'LockBoth',
  LOCK_ALL: 'LockAll',

  IsUnlockSingle(action) {
    return (action === this.UNLOCK_BOTH || action === this.UNLOCK_FINANCIAL || action === this.UNLOCK_LOGISTICAL);
  },

  IsLockSingle(action) {
    return (action === this.LOCK_BOTH || action === this.LOCK_FINANCIAL || action === this.LOCK_LOGISTICAL);
  },
  
  IsUnlock(action) {
    return (action === this.UNLOCK_BOTH || action === this.UNLOCK_FINANCIAL || action === this.UNLOCK_LOGISTICAL || action === this.UNLOCK_ALL);
  },

  IsLock(action) {
    return (action === this.LOCK_BOTH || action === this.LOCK_FINANCIAL || action === this.LOCK_LOGISTICAL || action === this.LOCK_ALL);
  }
};

export class CountriesOnHold extends Component {
  constructor(props) {
    super(props);

    let today = DATES.getTodayFormatted('yyyy-mm-dd');

    this.state = {
      open: false,
      action: "",
      modalCountryData: null,
      showWarning: null,
      date: today,
      pageSize: TableConfig.PAGINATION.STANDARD_LEVEL_ONE_PAGE_SIZE,
      page: 0
    };

    this.getStartAt = this.getStartAt.bind(this);
  }

  onOpenModal = (action, modalCountryData) => { 
    log.debug("Action, ", action);
    log.debug("CountryData, ", modalCountryData);
    log.debug("ShowWarning, ", modalCountryData.onHold.showWarningOnUnlock);
    this.setState({ modalCountryData: [modalCountryData], open: true, action: action, showWarning: [modalCountryData.onHold.showWarningOnUnlock], date: DATES.getTodayFormatted('yyyy-mm-dd')});
    log.clearAllDictionaryErrors();
  };
 
  onCloseModal = () => {
    log.debug("ShowWarning, ", this.state.showWarning);
    this.setState({ open: false });
  };

  unlockOrLockAllHandler(action) {
    log.debug("Action, ", action);
    log.debug("CountryData, ", this.props.countriesOnHold);
    const showWarnings = this.props.countriesOnHold.map((dataItem) => dataItem.onHold.showWarningOnUnlock);
    log.debug("ShowWarning, ", showWarnings);
    this.setState(({ open: true, action: action, modalCountryData: this.props.countriesOnHold, showWarning: showWarnings }));
    log.clearAllDictionaryErrors();
  }

  lockDate = (event) => {
    let lockDate = event;
    this.setState({
      date: lockDate
    })
  }

  unlockOrLockCountryHandler = () => {
    log.debug("Action, ", this.state.action);
    
    let countryCode = this.state.modalCountryData[0].countryCode;

    // If lock financial, logistical or both
    if (actions.IsLockSingle(this.state.action)) {
      let lockType;

      if (this.state.action === actions.LOCK_FINANCIAL) {
        lockType = 'Financial';
      } else if (this.state.action === actions.LOCK_LOGISTICAL) {
        lockType = 'Logistical';
      } else {
        lockType = 'Both';
      }
      
      // this should be the date from the s-datepicker in ActionsModal
      let lockDate = this.state.date;

      if (countryCode) {
        this.props.addCountryOnHoldLock(countryCode, lockType, lockDate, (response) => {
          if (response.ok) {
            log.setDictionaryMessage(ALL_MESSAGES.COUNTRIES_LOCKED_SUCCESS)
          } else {
            log.setDictionaryMessage(ALL_MESSAGES.ALL_COUNTRIES_LOCKED_ERROR)
          }
          //Refresh country on hold list
          this.props.getCountriesOnHold(this.getStartAt(this.state.page, this.state.pageSize), this.state.pageSize);
        });
      }
    }

    // If lock all
    // {this.state.action === actions.LOCK_ALL ? (
    //   log.setDictionaryMessage(ALL_MESSAGES.ALL_COUNTRIES_LOCKED_SUCCESS)
    // ):("");}
    
    // If unlock financial, logistical or both
    if (actions.IsUnlockSingle(this.state.action)) {
      let lockType;

      if (this.state.action === actions.UNLOCK_FINANCIAL) {
        lockType = 'Financial';
      } else if (this.state.action === actions.UNLOCK_LOGISTICAL) {
        lockType = 'Logistical';
      } else {
        lockType = 'Both';
      }

      if (countryCode) {
        this.props.removeCountryOnHoldLock(countryCode, lockType, (response) => {
          if (response.ok) {
            log.setDictionaryMessage(ALL_MESSAGES.COUNTRIES_UNLOCKED_SUCCESS)
          } else {
            log.setDictionaryMessage(ALL_MESSAGES.COUNTRIES_UNLOCKED_ERROR)
          }
          //Refresh country on hold list
          this.props.getCountriesOnHold(this.getStartAt(this.state.page, this.state.pageSize), this.state.pageSize);
        });
      }
    }

    // // If unlock all
    // {this.state.action === actions.UNLOCK_ALL ? (
    //   log.setDictionaryMessage(ALL_MESSAGES.ALL_COUNTRIES_UNLOCKED_SUCCESS)
    // ):("");}

    // TODO: wrap the following error messages in an if statement depending on API error response

    // commented out for the moment so we don't display both success and error messages

    // If lock financial, logistical or both
    // {this.state.action === "LockFinancial" || this.state.action === "LockLogistical" || this.state.action === "LockBoth" ? (
    //   log.setDictionaryMessage(ALL_MESSAGES.COUNTRIES_LOCKED_ERROR)
    // ):("");}

    // If lock all
    // {this.state.action === "LockAll" ? (
    //   log.setDictionaryMessage(ALL_MESSAGES.ALL_COUNTRIES_LOCKED_ERROR)
    // ):("");}
    
    // If unlock financial, logistical or both then
    // if (this.state.action === "UnlockFinancial" || this.state.action === "UnlockLogistical" || this.state.action === "UnlockBoth") {
    //   log.setDictionaryMessage(ALL_MESSAGES.COUNTRIES_UNLOCKED_ERROR)
    // }

    // If unlock all
    // {this.state.action === "UnlockAll" ? (
    //   log.setDictionaryMessage(ALL_MESSAGES.ALL_COUNTRIES_UNLOCKED_ERROR)
    // ):("");}

    this.onCloseModal();
  }

  getStartAt(page, pageSize) {
    return page * pageSize + 1;
  }

  fetchTableData(state, instance) {
    let page = Object.is(state.page, NaN) ? 0 : state.page;
    let pageSize = Object.is(state.pageSize, NaN) ? TableConfig.PAGINATION.STANDARD_LEVEL_ONE_PAGE_SIZE : state.pageSize;
    let startAt = this.getStartAt(page, pageSize);
    this.props.getCountriesOnHold(startAt, pageSize);
    this.setState({pageSize: pageSize, page: page});
  }

  render() {
    const columns = [{
      Header: <LanguageStringResolver string='countriesOnHold_Country'/>,
      accessor: 'countryCode',
      Cell: row =>
      <span>
        {this.props.countryList.map((value, index) => {
          return <span key={index}>{value.countryCode === row.value ? (<span>{value.countryName}</span>):("")} </span> 
        })}
          ({row.value})
      </span>
    }, {
      Header: <LanguageStringResolver string='countriesOnHold_FinancialData'/>,
      accessor: 'onHold.financialDataOnHoldFrom',
      Cell: row =>
      <span>
        {row.value ? (
          <span><LanguageStringResolver string='countriesOnHold_LockedUntil'/> {row.value}</span>
        ) :
          <span><LanguageStringResolver string='countriesOnHold_Unlocked'/></span>
        }
      </span>
    }, {
      Header: <LanguageStringResolver string='countriesOnHold_LogisticalData'/>,
      accessor: 'onHold.logisticalDataOnHoldFrom',
      Cell: row =>
      <span>
        {row.value ? (
          <span><LanguageStringResolver string='countriesOnHold_LockedUntil'/> {row.value}</span>
        ) :
          <span><LanguageStringResolver string='countriesOnHold_Unlocked'/></span>
        }
      </span>
    }, {
      Header: <LanguageStringResolver string='countriesOnHold_Actions'/>,
      accessor: 'actionsMenu',
      Cell: row => <ActionsMenu openModal={this.onOpenModal} modalCountryData={row.original} onHoldData={row.original.onHold} actions={actions}/>
    }]

    const NoDataComponent = props => (
        <NoData
            noDataText="countriesOnHold_NoData"
            {...props}
        />
    )

    /* Keeping this code for when we implement unlock/lock all */
    // let showUnlockButton = this.props.countriesOnHold && this.props.countriesOnHold.every(function (country) {
    //     return country.onHold.financialDataOnHoldFrom === "" && country.onHold.logisticalDataOnHoldFrom === "";
    // });

    // let showLockButton = this.props.countriesOnHold && this.props.countriesOnHold.every(function (country) {
    //   return country.onHold.financialDataOnHoldFrom !== "" && country.onHold.logisticalDataOnHoldFrom !== "";
    // });

    return (
        <s-container data-test="component-countries-on-hold">
            <div className="content-area CountriesOnHold">
                <h1>
                    <span>
                        <LanguageStringResolver string="countriesOnHold_PageTitle" />
                    </span>
                </h1>
                <p>
                    <LanguageStringResolver string="countriesOnHold_explanatoryText" />
                </p>
                <ApplicationMessages
                    scope={[FORM_NAME]}
                    messageType="applicationSuccess"
                    messageIds={[
                        ALL_MESSAGES.COUNTRIES_UNLOCKED_SUCCESS,
                        ALL_MESSAGES.COUNTRIES_LOCKED_SUCCESS,
                        ALL_MESSAGES.ALL_COUNTRIES_UNLOCKED_SUCCESS,
                        ALL_MESSAGES.ALL_COUNTRIES_LOCKED_SUCCESS,
                    ]}
                />
                <ApplicationMessages
                    scope={[FORM_NAME]}
                    messageType="applicationError"
                    messageIds={[
                        ALL_MESSAGES.COUNTRIES_UNLOCKED_ERROR,
                        ALL_MESSAGES.COUNTRIES_LOCKED_ERROR,
                        ALL_MESSAGES.ALL_COUNTRIES_UNLOCKED_ERROR,
                        ALL_MESSAGES.ALL_COUNTRIES_LOCKED_ERROR,
                    ]}
                />
                {/* Keeping this code for when we implement unlock/lock all */}
                {/* <div className="mb20">
                    {showLockButton === true ? (
                        <button
                            data-test="button-lock-all-disbaled"
                            className="tertiary"
                            disabled
                            onClick={this.unlockOrLockAllHandler.bind(this, 'LockAll')}
                        >
                            <s-icon class="pr5" name="lock-filled" aria-label="lock-filled"></s-icon>
                            <LanguageStringResolver string="countriesOnHold_LockAll" />
                        </button>
                    ) : (
                        <button data-test="button-lock-all" className="tertiary" onClick={this.unlockOrLockAllHandler.bind(this, 'LockAll')}>
                            <s-icon class="pr5" name="lock-filled" aria-label="lock-filled"></s-icon>
                            <LanguageStringResolver string="countriesOnHold_LockAll" />
                        </button>
                    )}

                    {showUnlockButton === true ? (
                        <button
                            data-test="button-unlock-all-disbaled"
                            className="tertiary"
                            disabled
                            onClick={this.unlockOrLockAllHandler.bind(this, 'UnlockAll')}
                        >
                            <s-icon class="pr5" name="lock" aria-label="lock"></s-icon>
                            <LanguageStringResolver string="countriesOnHold_UnlockAll" />
                        </button>
                    ) : (
                        <button data-test="button-unlock-all" className="tertiary" onClick={this.unlockOrLockAllHandler.bind(this, 'UnlockAll')}>
                            <s-icon class="pr5" name="lock" aria-label="lock"></s-icon>
                            <LanguageStringResolver string="countriesOnHold_UnlockAll" />
                        </button>
                    )}
                </div> */}
                <ReactTable
                    minRows={0}
                    maxRows={0}
                    data={this.props.countriesOnHold}
                    columns={columns}
                    defaultPageSize={TableConfig.PAGINATION.STANDARD_LEVEL_ONE_PAGE_SIZE}
                    pages={Math.ceil(this.props.countriesOnHoldCount / this.state.pageSize)}
                    pageSizeOptions={TableConfig.PAGINATION.STANDARD_PAGE_SIZE_OPTIONS}
                    NoDataComponent={NoDataComponent}
                    PaginationComponent={Pagination}
                    showPagination={true}
                    className="mb30"
                    sortable={false}
                    manual
                    onFetchData={this.fetchTableData.bind(this)}
                />
                <ActionsModal
                    actions={this.actions}
                    action={this.state.action}
                    countryMappings={this.props.countryList}
                    open={this.state.open}
                    onCloseModal={this.onCloseModal}
                    showWarning={this.state.showWarning}
                    modalCountriesOnHold={this.state.modalCountryData}
                    date={this.state.date}
                    unlockOrLockAllHandler={this.unlockOrLockAllHandler}
                    unlockOrLockCountryHandler={this.unlockOrLockCountryHandler}
                    lockDate={this.lockDate}
                />
            </div>
        </s-container>
    );
  }
}

let mapStateToProps = function (state) {
    return {
        countriesOnHold: state.countriesOnHold.data && state.countriesOnHold.data.data,
        countriesOnHoldCount: state.countriesOnHold.data && state.countriesOnHold.data.totalCount,
        countryList : (state.content && state.content.contentData && state.content.contentData.countryList)
    };
};

let mapDispatcherToProps = function(dispatch) {
  return {
      getCountriesOnHold: (startAt, count) => {
          dispatch(COUNTRIESONHOLD_CONTROLLER.doGetCountriesOnHold(startAt, count));
      },
      removeCountryOnHoldLock: (countryCode, lockType, callback) => {
          dispatch(COUNTRIESONHOLD_CONTROLLER.doRemoveCountryOnHoldLock(countryCode, lockType, callback));
      },
      addCountryOnHoldLock: (countryCode, lockType, lockDate, callback) => {
        dispatch(COUNTRIESONHOLD_CONTROLLER.doAddCountryOnHoldLock(countryCode, lockType, lockDate, callback));
    },
  };
}

export default  authorize({
  name: 'CountriesOnHold',
  resource: connect(mapStateToProps, mapDispatcherToProps)(CountriesOnHold)
}, AuthorizedResource, {
  showNotAuthorized: true
});
